import { getBRCurrencyFormat } from '@app/utils/formmater';
import React from 'react';
import classes from './styles.module.css';

type Props = {
  subtotal: number;
  deliveryTax: number | null;
  total: number;
};

export default function BillingInformation({ subtotal, deliveryTax, total }: Props) {
  return (
    <div className={classes.container}>
      <div className={classes.boxPrices}>
        {subtotal !== total && (
          <div className={classes.priceSum}>
            <span>Sobtotal</span>
            <span>{getBRCurrencyFormat(subtotal)}</span>
          </div>
        )}

        {(deliveryTax ?? 0) > 0 && (
          <div className={classes.priceSum}>
            <span>Taxa de entrega</span>
            <span> {getBRCurrencyFormat(deliveryTax ?? 0)}</span>
          </div>
        )}

        <div className={classes.priceTotal}>
          <span>Total</span>
          <span>{getBRCurrencyFormat(total)}</span>
        </div>
      </div>
    </div>
  );
}
